var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4734 19.5256H5.55389L17.4638 7.60777L16.9236 7.06717L16.3834 6.52656L4.4734 18.4444V19.5256ZM3 21V17.8547L17.4393 3.4058C17.7176 3.12731 18.0655 2.99216 18.4829 3.00035C18.9004 3.00854 19.2483 3.15188 19.5266 3.43038L20.5825 4.48701C20.8608 4.7655 21 5.10952 21 5.51907C21 5.92862 20.8608 6.27264 20.5825 6.55114L6.14325 21H3ZM19.4529 5.4945L18.4461 4.48701L19.4529 5.4945ZM17.4638 7.60777L16.9236 7.06717L16.3834 6.52656L17.4638 7.60777Z",
    fill: "#8890A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.56cdb50a9f2ab7321dbe49e2cc72887b.svg";
export { ForwardRef as ReactComponent };